'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require('@/utils');

exports.default = {
  props: {
    ratio: {
      type: String,
      validate: function validate() {
        return (0, _utils.oneOf)(['24/0', '5/19', '17/7']);
      },

      default: '24/0'
    }
  },
  data: function data() {
    return {};
  },

  computed: {
    size: function size() {
      return this.ratio.split('/');
    }
  },
  components: {},
  created: function created() {},

  methods: {}
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//